import { DriveMountStatusBadge } from '@frameio/connected-surfaces';
import type { IconProps } from '@frameio/vapor-icons';
import { MountedStorageIcon } from '../../icons';

type MountedStorageStatusIconProps = IconProps & {
  projectId?: string;
  /** Ring around the badge; match the surface behind the icon. */
  borderColor?: string;
};

/**
 * Drive icon badged with the project's Drive mount status. Icon props such as
 * the `size` and `aria-hidden` that Vapor buttons clone onto their icons are
 * forwarded to the icon.
 */
export function MountedStorageStatusIcon({
  projectId,
  borderColor,
  ...iconProps
}: MountedStorageStatusIconProps) {
  if (!projectId) return <MountedStorageIcon {...iconProps} />;

  return (
    <DriveMountStatusBadge borderColor={borderColor} projectId={projectId}>
      <MountedStorageIcon {...iconProps} style={{ display: 'block' }} />
    </DriveMountStatusBadge>
  );
}
